import ExpandBoard from "graphics/icons/Board/ExpandBoard";
import React from "react";

const BoardImage = ({ luid, given_name, onClick = null, shown }) => {
  return (
    <div
      className={`board-image`}
      id={`${luid}-board-image`}
      onClick={onClick}
      style={{ display: shown ? "" : "none" }}
    >
      <ExpandBoard />
      <div className="board-name">
        <span>
          <span className="dotdotdot">{given_name}</span>
          {`'s`}
        </span>
        <br />
        <span>{`whiteboard`}</span>
      </div>
    </div>
  );
};

export default BoardImage;
